var _circle, _path, _path2, _rect, _path3, _path4, _line, _line2, _line3, _line4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDroneActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 24.5,
    r: 24.5,
    fill: "#3B3B3B",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.7383 27.1335V23.137L31.4912 20.8057H18.2334L15.3875 23.137V27.1335",
    stroke: "#3B3B3B",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5462 24.6024L31.4219 20.8057H17.817L19.5798 24.6024H29.5462Z",
    stroke: "#3B3B3B",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: 1,
    width: 17.2114,
    height: 4.68223,
    rx: 2.34111,
    transform: "matrix(-1 0 0 1 32.3672 14.4775)",
    stroke: "#3B3B3B",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5938 16.502C41.146 16.502 41.5938 16.9497 41.5938 17.502C41.5938 18.0542 41.146 18.502 40.5938 18.502V16.502ZM34.8987 18.502H33.8987V16.502H34.8987V18.502ZM40.5938 18.502H34.8987V16.502H40.5938V18.502Z",
    fill: "#3B3B3B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1016 16.502H16.1016V18.502H15.1016V16.502ZM9.40648 18.502C8.8542 18.502 8.40648 18.0542 8.40648 17.502C8.40648 16.9497 8.8542 16.502 9.40648 16.502V18.502ZM15.1016 18.502H9.40648V16.502H15.1016V18.502Z",
    fill: "#3B3B3B"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: -1,
    x2: 1.50583,
    y2: -1,
    transform: "matrix(4.37103e-08 1 1 -4.37103e-08 38.6094 15.1104)",
    stroke: "#3B3B3B",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: -1,
    x2: 1.50583,
    y2: -1,
    transform: "matrix(4.37103e-08 1 1 -4.37103e-08 12.2188 15.1104)",
    stroke: "#3B3B3B",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: -1,
    x2: 2.79672,
    y2: -1,
    transform: "matrix(-1 0 0 1 39.6445 15.1104)",
    stroke: "#3B3B3B",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: -1,
    x2: 2.79672,
    y2: -1,
    transform: "matrix(-1 0 0 1 13.4844 15.1104)",
    stroke: "#3B3B3B",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6094 27.0078L24.6094 28.6784",
    stroke: "#3B3B3B",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6094 30.3486L24.6094 32.0192",
    stroke: "#3B3B3B",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6094 33.6904L24.6094 35.361",
    stroke: "#3B3B3B",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6406 27.0078L21.0658 28.5764",
    stroke: "#3B3B3B",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4883 30.1445L19.9135 31.7131",
    stroke: "#3B3B3B",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3398 33.2812L18.765 34.8498",
    stroke: "#3B3B3B",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9453 27.0078L28.5201 28.5764",
    stroke: "#3B3B3B",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0977 30.1445L29.6725 31.7131",
    stroke: "#3B3B3B",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2461 33.2812L30.8209 34.8498",
    stroke: "#3B3B3B",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDroneActive);
export default __webpack_public_path__ + "static/media/droneActive.03aae7d8a2bd30c864cc8d77d2da672a.svg";
export { ForwardRef as ReactComponent };